import { Role } from "@/graphql/__generated__/graphql";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type State = {
  orgName: string;
  orgId: number;
  userId: number;
  userRole: Role | string;
  isConfigAdmin: boolean;
}

type Actions = {
  setUser: (_user: Partial<State>) => void;
  reset: () => void;
}

const initialState: State = {
  orgName: "",
  orgId: 0,
  userId: 0,
  userRole: "",
  isConfigAdmin: false,
};

const useUserStore = create<State & Actions>()(
  persist(
    (set) => ({
      ...initialState,
      setUser: (user) => set((state) => ({ ...state, ...user })), // Update only provided properties
      reset: () => set({ ...initialState }),  // Reset state to initialState
    }),
    {
      name: "shield-store",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default useUserStore;
